export enum VideoAssistantRefereeAttribute {
  PossibleGoal = 411,
  PossiblePenalty = 412,
  PossibleRedCard = 413,
  PossibleYellowCard = 3018,
  PossibleCorner = 3019,
}
